import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import './AboutUs.css';
import capitalLogo from '../../images/capitalnature.png';
import ardonLogo from '../../images/Ardom.png';
import mopLogo from '../../images/MOP_logo.png';

function AboutUs() {
    return (
        <section id='about'>
            <div className="about-bg">

                <Container fluid>
                    <Row className='col-op-first'>
                        <Col lg={6}>
                            <div className='col-sol-first-div'>
                                <h1>
                                    About Us
                                </h1>
                            </div>
                        </Col>
                        <Col lg={6}>
                        </Col>
                    </Row>
                </Container>
                <Container fluid>
                    <Row className='about-col-op'>
                        <Col lg={2}>
                            <div className="about-logos">
                                <h2>Partners:</h2>
                                <img src={capitalLogo} alt="" />
                                <img src={ardonLogo} alt="" />
                                <img src={mopLogo} alt="" />
                            </div>
                        </Col>
                        <Col lg={10} className=' p-0 m-0'>

                            <div className='clip-tomato'>
                                <div className='about-img-txt-container'>
                                    <div className='about-1'></div>
                                    <div className='about-txt'>
                                        Founded in 2021, ViaCool is funded and supported<br/>
                                        by Capital Nature, a leading investment company<br/>
                                        that focuses on investing in early-stage companies<br/>
                                        with ground breaking technologies in the field<br/>
                                        of sustainability and by Ardom Telcom, a leader
                                    </div>
                                </div>


                                <div className='about-img-txt-container'>
                                    <div className='about-2'></div>
                                    <div className='about-txt'>
                                        in ERP for precise agriculture, cold storage and<br/>
                                        transportation management.<br/>
                                        Our company mission is to become the trusted<br/>
                                        partner in the fruit and vegetable supply chain,<br/>
                                        helping to minimize losses and improve food scarcity.
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </section>
    )
}

export default AboutUs
